<template>
  <div class="main" id="main" ref="boxHeighr">
    <div class="headerBox">
      <div class="listTit">
        <span class="ranking">排名</span>
        <span class="lane">靶位</span>
        <span class="org van-hairline--left">单位</span>
        <span class="totalScore van-hairline--left">成绩</span>
      </div>
    </div>
    <div class="matchList">
      <van-list finished>
        <van-cell v-for="(item,n) in showData.value" :key="n" :title="item">
          <div class="matchName" :class="item.remark">
            <div  class="borderBox van-hairline--bottom orgName"  >
              <span class="ranking">{{item.ranking}}</span>
              <span class="lane">{{item.lane}}</span>
              <span class="org">
                <sapn>{{item.org}}</sapn>
              </span>
              <span class="totalScore">{{item.totalScore}}</span>
            </div>
            <div class="svgBox"  :class="{borderred:item.isSoff}">
              <div class="eliminatedBox " v-if="item.eliminated == 2"></div>
              <div class="stageScoreslist" ref="stageScoreslist">
                <div class="tableHeaderShow" v-for="(data,n) in state.projectInfo.tableHeaderShow" :key="n">
                  <!-- <span v-if="item.stageScores.length>n">{{data}}</span>
                  <span v-if="item.stageScores.length>n">{{reverseFun(item.stageScores)[n].score}}</span> -->
                  <span>{{data}}</span>
                  <span>{{item.stageScores[n]?item.stageScores[n].score:''}}</span>
                </div>
              </div>
              <div class="svgItem" ref="svgItem">
                <div class="targetContainer">
                  <div :class="{ shotType: item.sight == 1 }"></div>
                  <div class="playerName"></div>
                  <div class="name">{{item.playerName}}</div>
                  <div class="playerscore" v-if="item.position.length>0">{{item.position[item.position.length-1].score}}</div>
                  <component
                    v-if="svgshow"
                    v-bind:is="svgName"
                    :dataitem="item.isSoff ? item.soffPosition : item.position"
                    :lastscore="lastPosition(item)"
                  ></component>
                  <!-- :dataitem="item.eliminated != 2?datatime(n,item):{}" -->
                </div>
              </div>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, toRefs, onMounted } from "vue";
import Paho from "../../common/js/mqtt.js";
import { useRouter } from "vue-router";
import { createState } from "../../store";
import svgm10ar from "../../components/10m/svg10mAR.vue";
import svgm10ap from "../../components/10m/svg10mAP.vue";
import svgm50ar from "../../components/50m/svg50mAR.vue"//步枪
import svgm50ap from "../../components/50m/svg50mAP.vue"
var opt;
export default {
  components: { svgm10ar, svgm10ap,svgm50ar, svgm50ap },
  setup(props, { refs, root }) {
    const data = reactive(createState)
    return {
        state: reactive(createState),
        svgshow:ref(false)
    };
  },
  props: {
    //指定接收的值，必须指定类型
    showData: Object,
    svgName: String
  },
  methods: {
    reverseFun(data){
      return data.reverse()
    },
    datatime(index, item) {
      if (this.showData.value.length != index) {
        const list = [];
        if(item.isSoff){
          list.push({...this.showData.value[index].soffPosition[this.showData.value[index].soffPosition.length-1]}) 
          return list
        }else{
          list.push({...this.showData.value[index].position[this.showData.value[index].position.length-1]}) 
          return list
        }
      }
    },
    showName(index) {
      if (this.showData.value.length != index) {
        return this.showData.value[index + 1];
      }
    },
    lastPosition(item) {
      const data = item.isSoff ? item.soffPosition : item.position;
      if (data.length > 0) {
        let position = data[data.length - 1];
        return position.score;
      } else {
        return "";
      }
    }
  },
  mounted() {
    console.log("这是资格赛");
    console.log(this.$refs.stageScoreslist[0].clientHeight   )
    console.log(this.stageScoreslistHeight )
    
    this.$refs.boxHeighr.style.setProperty("--ItemHeight",this.$refs.stageScoreslist[0].clientHeight+'px')
    this.svgshow = true
    console.log(this.svgshow)
  }
};
</script>

<style lang="less" scoped>
.boxHeighr{
  --ItemHeight:2.5rem;
}
.svgStyle{
  height: var(--ItemHeight);
}
.svgBox {
  width: 99.5%;
  min-height: 2.5rem;
  // padding: 0 2%;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  .eliminatedBox{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: #000;
    z-index: 4;
    opacity: 0.3;
  }
  // border-bottom: 1px solid #333;
}
.stageScoreslist{
  width: 50%;
  min-height: 2.5rem;
  float: left;
  .tableHeaderShow{
    width: 100;
    height: 0.4rem;
    line-height: 0.4rem;
    span{
      float: left;
      width: 50%;
      height: 0.4rem;
      border-bottom: 1px solid #999;
    }
  }
}
.svgItem {
  width: 50%;
  min-height: var(--ItemHeight);
  float: left;
}
.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.headerBox {
  width: 100%;
  height: 1rem;
  position: fixed;
  background: #fff;
  z-index: 10;
  border-bottom: 1px solid #333;
  .title {
    background: #39a9ed;
    height: 1rem;
    width: 100%;
    display: block;
    /deep/.van-ellipsis {
      color: #fff;
      max-width: 80%;
      font-size: 0.4rem;
    }
  }
  .listTit {
    width: 96%;
    padding: 0 2%;
    height: 1rem;
    background: #fff;
    text-align: center;
    font-size: 0.4rem;
    font-weight: 700;
    line-height: 1rem;
    border-top: 1px solid #333;
  }
}
.oddcolor {
  background: #ffffcc;
}
.ranking {
  display: block;
  width: 13%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.orgName {
  background: #6699cc;
  color: #fff;
}
.lane{
  display: block;
  width: 13%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.org {
  display: block;
  width: 37%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.orgsvg {
  display: block;
  width: 100%;
  min-height: 2rem;
  float: left;
  line-height: 1rem;
  position: absolute;
  top: 0;
  left: 28%;
  overflow: hidden;
  z-index: 2;
}
.currentCount {
  display: block;
  width: 15%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.totalScore {
  display: block;
  width: 33%;
  height: 100%;
  float: left;
  line-height: 1rem;
}
.QF {
  background-color: red;
  color: #fff;
}
.matchList {
  margin-top: 1rem;
  flex: 1;
  height: auto;
  width: 100%;
  background: #fff;
  .van-list {
    width: 100%;
    height: 100%;
    .matchName {
      font-weight: 700;
      width: 100%;
      min-height: 3.6rem;
      text-align: left;
      line-height: 1rem;
      font-size: 0.3rem;
      text-align: center;
      .borderBox {
        width: 96%;
        height: 1rem;
        padding: 0 2%;
        position: relative;
        overflow: hidden;
        // border-bottom: 1px solid #333;
        font-size: 0.4rem;
      }
      .icon {
        width: 0.2rem;
        height: 1rem;
        line-height: 1rem;
        float: left;
      }
    }
  }
}
.targetContainer {
  width: 100%;
  // min-height: 2.5rem;
  // height: 100%;
  min-height: var(--ItemHeight);
  transform: scale(var(--transScale));
  margin-top: var(--margin);
  box-sizing: border-box;
  border: 2px solid white;
  background: white;
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  .name {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 70%;
    overflow: hidden;
    height: 0.6rem;
    line-height: 0.6rem;
    font-weight: 700;
    font-size: 0.4rem;
    color: #fff;
    text-align: left;
    text-indent: 0.2rem;
  }
  .playerscore {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 0.6rem;
    line-height: 0.6rem;
    font-weight: 700;
    font-size: 0.4rem;
    color: #fff;
    // text-align: right;
    text-indent: 2rem;
  }
  .playerName {
    z-index: 2;
    width: 100%;
    height: 0.6rem;
    background-color: #333399;
    opacity: 0.7;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>